import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Title from "antd/lib/typography/Title";

export default function FeatureWithIcon({
  reverse,
  title,
  subtitle,
  icon,
  imageSource,
  vertical,
}) {
  let iconElement = null;

  if (imageSource) {
    // If icon is a string, assume it's a FontAwesome icon name
    // Use the icon string as an image source
    iconElement = (
      <div
        style={{
          marginLeft: 20,
          marginRight: 20,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "white",
          borderRadius: 7,
          marginTop: vertical ? 7 : 0,
          marginBottom: vertical ? 18 : 0,
          padding: "10px 15px",
        }}
      >
        <img src={imageSource} height={20} style={{padding: 0, margin: 0}} />
      </div>
    );
  }

  if (icon) {
    iconElement = (
      <div
        style={{
          marginLeft: 20,
          marginRight: 20,
          display: "flex",
          justifyContent: vertical ? "flex-start" : "center",
          alignItems: vertical ? "flex-start" : "center",
          backgroundColor: "#6292f0",
          border: "15px solid #6292f0",
          borderRadius: 99,
          marginBottom: vertical ? 15 : 0,
        }}
      >
        <FontAwesomeIcon
          icon={icon}
          style={{
            fontSize: 20,
            width: 20,
            height: 20,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: vertical
          ? "column-reverse"
          : reverse
          ? "row-reverse"
          : "row",
        justifyContent: "flex-end", // horizontal
        alignItems: "center", // vertical
        marginTop: 20,
        marginBottom: 20,
        paddingLeft: 20,
        paddingRight: 20,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignContent: "center",
          textAlign: reverse ? "left" : "right",
        }}
      >
        <h3 style={{ margin: 0, marginBottom: 5, textAlign: vertical ? "center" : "left" }}>
          {title}
        </h3>
        <p
          style={{
            margin: 0,
            fontSize: 14,
            textAlign: vertical ? "center" : "left",
          }}
        >
          {subtitle}
        </p>
      </div>
      {iconElement}
    </div>
  );
}
